<div class="container">
  <ion-button
    fill="clear"
    class="close-button"
    (click)="dismiss()"
    aria-label="close"
  >
    <ion-icon
      color="secondary"
      slot="icon-only"
      name="close-outline"
    ></ion-icon>
  </ion-button>

  <img
    class="welcome-onboarding__image"
    src="assets/images/img-key.webp"
    alt=""
    decoding="async"
    loading="eager"
  />

  <h1 class="ion-no-margin">
    @if ((propertyName$ | async); as propertyName) { @if (propertyName) { {{
    "shared.welcomeOnboarding.titleWithProperty.prefix" | transloco }}
    <ion-text color="secondary">
      <span> {{ propertyName }} </span>
    </ion-text>
    } @else { {{ "shared.welcomeOnboarding.title" | transloco }} } } @else { {{
    "shared.welcomeOnboarding.title" | transloco }} }
  </h1>

  <p
    class="welcome-onboarding__description"
    [innerHTML]="'shared.welcomeOnboarding.description' | transloco"
  ></p>

  <div class="welcome-onboarding__actions">
    <ion-button
      expand="block"
      shape="round"
      class="welcome-onboarding__cta"
      (click)="dismiss()"
    >
      {{ "shared.welcomeOnboarding.cta" | transloco }}
    </ion-button>
  </div>
</div>
